import React from 'react';
import {Trans} from 'react-i18next';
import { withTranslation } from 'react-i18next';
import {connect} from 'react-redux';
import { APP_URL } from '../../../../../../utils';
import './index.css';

class UpgradePage extends React.Component {

	render() {
		return (
			<div className="upgrading-page container d-flex flex-column justify-content-center text-center">
				<img className="mx-auto mt-3" src={`https://www.getsharedcontacts.com/wp-content/uploads/2020/06/upgrade-error.png`} alt=""/>
				<div className="mt-4">
					<p>{this.props.t("textUpgradePage1")}&nbsp;
						{
							this.props.profile !== null
								?
								this.props.profile.domain !== null
									?
									<strong>{this.props.profile.domain.plan}</strong>
									:
									<strong>{this.props.t("adminScreenStatus8")}</strong>
								:
								<strong>{this.props.t("adminScreenStatus8")}</strong>
						}
						&nbsp; <Trans i18nKey="textUpgradePage2" components={{strong :<strong className="text-nowrap"/>}}/></p>
					<p>{this.props.t("textMigrationFailedContent2")}<br /><Trans i18nKey="textStatusDescription1" components={{a: <a href={`${APP_URL}/support`}> </a>}} /></p>
				</div>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
        profile: state.profileReducer.getProfile,
	};
};

export default connect(mapStateToProps)(withTranslation()(UpgradePage));
